"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import API from "@ym-framework/api-utils";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchCancelAdmin = class extends Mixins(AccountSessionMixins) {
  get show() {
    return true;
  }
  cancelAdmins() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(this.$t("team_management.cancel_admins_component"), this.$t("team_management.cancel_admins.title"));
        yield API.post(`api://base.auth.pro/v1/virtual-desktop-admins`, {
          vdIds: [],
          userIds: ((selectItems) => {
            let items = [];
            for (let item of selectItems) {
              items.push(item.guid);
            }
            return items;
          })(this._controller),
          isCoverage: true,
          mode: "REPLACE",
          type: "USER"
        });
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("selectItem")
], BatchCancelAdmin.prototype, "_controller", 2);
BatchCancelAdmin = __decorateClass([
  Component
], BatchCancelAdmin);
export {
  BatchCancelAdmin as default
};
